import React from 'react';
import { useTranslation } from 'react-i18next';
import { JourneyAddressDto, RequestedTimeType } from '../../../../models/journey';
import './TripDetailsRoute.scss';
import  dayjs from 'dayjs';

interface TripDetailsRouteProps {
  title: string,
  pickUp: JourneyAddressDto,
  dropOff: JourneyAddressDto,
  earliestPickUpDateTime: string,
  latestPickUpDateTime: string,
  latestDropOffDateTime: string
}

const TripDetailsRoute = ({
  title,
  pickUp,
  dropOff,
  earliestPickUpDateTime,
  latestPickUpDateTime,
  latestDropOffDateTime
}: TripDetailsRouteProps) => {
  const { t } = useTranslation();

  const formatTime = (date: string) => {
    return dayjs(date).format(t('trips.times.format'));
  };

  return (
    <div className="TripDetailsRoute">
      <h3 className="TripDetailsRouteTitle">{title}</h3>
      <div className="TripDetailsRouteItem">
        <div className="TripDetailsRouteItemDesc">
          <span>
            <strong>{t('trips.route.From')}</strong>
            {pickUp?.longFormattedDesc}
          </span>
        </div>
      </div>
      <div className="TripDetailsRouteItem">
        <div className="TripDetailsRouteItemDesc">
          <span>
            <strong>{t('trips.route.To')}</strong>
            {dropOff?.longFormattedDesc}
          </span>
        </div>
      </div>
      <div className="TripDetailsRouteTimes">
        <div>
          <h3 className="TripDetailsRouteTimesTitle">{t('trips.times.pickup')}</h3>
          <span
            className="TripDetailsRouteTimesValue"
            dangerouslySetInnerHTML={{ __html: t('trips.times.pickupTime', { from: formatTime(earliestPickUpDateTime), to: formatTime(latestPickUpDateTime) }) }}
          />
        </div>
        <div>
          <h3 className="TripDetailsRouteTimesTitle">{t('trips.times.arrivalTimeLabel')}</h3>
          <span className="TripDetailsRouteTimesValue">{formatTime(latestDropOffDateTime)}</span>
        </div>
      </div>
    </div>
  );
};

export default TripDetailsRoute;